import React from "react";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import Scroll from "../Header/Scroll";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import Map from "./components/Map";
import Form from "./components/Form";
import Image from "../../assets/images/lagoon.jpg";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(0,0,95,0.5),rgba(0,0,95,0.5)), url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Contact = () => {
  return (
    <Box>
      <Scroll>
        <AppBar
          position={"sticky"}
          elevation={0}
          sx={{
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Map />
      </Box>
      <Box>
        <Container>
          <Form />
        </Container>
      </Box>
      <Box bgcolor={"#000058"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Contact;
